import { Grid } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

import { Text } from '../react-components/Text';

export const DividerWithText = ({ text }: { text: string }) => (
  <Grid container direction="row" wrap="nowrap" alignItems="center" style={{ margin: `10px 0` }}>
    <div style={{ height: `1px`, width: `100%`, backgroundColor: RoutalPalette.secondary00 }} />

    <Text
      variant="label"
      intlId="driver.add_stops"
      style={{
        width: `100%`,
        textAlign: `center`,
        fontSize: `14px`,
        textWrap: `nowrap`,
        padding: `0 10px`,
      }}
    >
      {text}
    </Text>

    <div style={{ height: `1px`, width: `100%`, backgroundColor: RoutalPalette.secondary00 }} />
  </Grid>
);
